module.exports = __webpack_public_path__ + "img/nav-tick.5e5c7315.svg";